import { HttpClient, RequestParams } from "./base/BaseHttpClient";
import { ProjectOverviewDto } from "./contracts/models";

export class ProjectOverviewApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ProjectOverview
   * @name GetProjectOverview
   * @request GET:/api/project-overview/{projectId}
   * @response `200` `ProjectOverviewDto` OK
   */
  getProjectOverview = (projectId: string, params: RequestParams = {}) =>
    this.http
      .request<ProjectOverviewDto, any>({
        path: `/api/project-overview/${projectId}`,
        method: "GET",
        credentials: "include",
        format: "json",
        ...params,
      })
      .then((m) => m.data);
}
